export default {"src":"/_next/static/media/karePediaSecondLogo.ecfe5339.gif","height":93,"width":145,"blurWidth":0,"blurHeight":0};